import LettuceTalkLogo from "../images/logo.png";
import { useState } from "react";
import SpeechBubble from "./SpeechBubble";

function CultureQuestion(props) {
  const supportedLanguages = [
    { value: '', label: 'No translation needed' },
    { value: 'Korean', label: 'Korean' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'Simplified Chinese', label: 'Simplified Chinese' },
    { value: 'Traditional Chinese', label: 'Traditional Chinese' },
    { value: 'Vietnamese', label: 'Vietnamese' },
    { value: 'Tagalog', label: 'Tagalog' },
    { value: 'Portuguese', label: 'Portuguese' },
    { value: 'Italian', label: 'Italian' },
    { value: 'Japanese', label: 'Japanese' },
    { value: 'Hindi', label: 'Hindi' },
    { value: 'Arabic', label: 'Arabic' },
    { value: 'Russian', label: 'Russian' },
    { value: 'French', label: 'French' },
    { value: 'German', label: 'German' }
  ];

  // Top possible culture/circumstance options
  const cultureOptions = [
    "Language barrier",
    "Long-distance",
    "Finances",
    "Job loss",
    "Religion",
    "Disability",
    "Burnout",
    "Sandwich generation",
    "Young caregiver",
  ];

  const [cultureContext, setCultureContext] = useState("");
  const [translationLanguage, setTranslationLanguage] = useState('');
  const initialSelectedContext = Object.fromEntries(
    cultureOptions.map(option => [option, false])
  );
  const [selectedContext, setSelectedContext] = useState(initialSelectedContext);

  const handleCultureOptionClick = (option) => {
    setSelectedContext(prev => ({
      ...prev,
      [option]: !prev[option],
    }));
    console.log("Toggled option:", option, "New selectedContext:", {
      ...selectedContext,
      [option]: !selectedContext[option],
    });
  };

  const handlePreviousClick = () => {
    if (props.onPreviousClick) props.onPreviousClick();
  };

  const handleNextClick = () => {
    const response = {
      translationLanguage: translationLanguage,
      cultureContext: cultureContext,
      selectedContext: selectedContext,
    };
    console.log("Submitting CultureQuestion response:", response);
    if (props.onNextClick) props.onNextClick(response);
  };

  return (
    <div className="flex flex-col items-center rounded-lg max-w-lg p-8">
      <img className="w-28" src={LettuceTalkLogo} alt="Lettucetalk logo, a round baby lettuce sitting on top of a parent lettuce" />

      <SpeechBubble
        header="Step 2. Care Context"
        subtitle="Tell us about any cultural, language, or life circumstances that shape your family's caregiving situation."
      />
      <div className="card-body shadow-xl bg-white rounded-3xl mb-4">
        <div className="text-sm text-gray-600 mb-4 text-center">
          <div className="mt-2">
            Select any that apply and add your own details below.
          </div>
        </div>

        {/* Toggle buttons for culture/circumstance options */}
        <div className="flex flex-row flex-wrap mb-4">
          {cultureOptions.map(option =>
            <button
              key={option}
              className={`btn m-1 ${selectedContext[option] ? "btn-primary" : ""}`}
              type="button"
              onClick={() => handleCultureOptionClick(option)}
            >
              {option}
            </button>
          )}
        </div>

        <label className="form-control w-full">
          <span className="mb-2">Would you like your cards translated?</span>
          <span className="label-text-alt mb-2">Cards will include both English and the selected language</span>
          <select
            className="select select-bordered w-full"
            value={translationLanguage}
            onChange={(e) => {
              setTranslationLanguage(e.target.value);
              console.log("Updated translationLanguage:", e.target.value);
            }}
          >
            {supportedLanguages.map((lang) => (
              <option key={lang.value} value={lang.value}>{lang.label}</option>
            ))}
          </select>
        </label>

        <div className="mt-4 mb-2">Anything you'd like to add regarding your family’s culture, background, or circumstances? (optional)</div>
        <textarea
          placeholder="My parents speak Korean, but my kids only speak English. We live far apart and recently lost a job."
          value={cultureContext}
          onChange={e => {
            setCultureContext(e.target.value);
            console.log("Updated cultureContext:", e.target.value);
          }}
          maxLength={260}
          className="textarea textarea-bordered w-full mb-4"
        />
      </div>
      <div className="flex flex-row space-x-2">
        <button
          className="btn"
          onClick={handlePreviousClick}
        >
          Previous
        </button>
        <button
          className="btn btn-primary"
          onClick={handleNextClick}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default CultureQuestion;
